import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get, put } from '../http';
import { activeSnack } from './common';

// import { covertToJSON } from '../../utils/stateToJson';

// --- API THUNKS START ---
export const getSettingsDetails = createAsyncThunk('settings/details', async ({ dispatch }) => {
  try {
    const response = await get(`/settings/all`);
    if (response) {
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});

export const updateSettingsDetails = createAsyncThunk(
  'settings/update',
  async ({ state, settingsId, dispatch, navigate }) => {
    try {
      const response = await put(`/settings/${settingsId}`, state);
      if (response) {
        dispatch(activeSnack({ type: 'success', message: 'Settings updated successfully!' }));
        // navigate(paths.dashboard.root);
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
// --- REDUX SLICE START ---
export const settings = createSlice({
  name: 'settings',
  initialState: {
    loading: false,
    error: {},
    staffDropList: [],
    settingsDetails: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    // get settings details
    [getSettingsDetails.pending]: (state) => {
      state.loading = true;
    },
    [getSettingsDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.settingsDetails = action.payload;
      state.error = {};
    },
    [getSettingsDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // update settings details
    [updateSettingsDetails.pending]: (state) => {
      state.loading = true;
    },
    [updateSettingsDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.settingsDetails = action.payload;
      state.error = {};
    },
    [updateSettingsDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});

export const { clearStaffError } = settings.actions;

export default settings.reducer;
